export { auth } from './chunk-BDHIX2MJ.js';
export { JwApiError, jwApi } from './chunk-FDFVITOH.js';
import './chunk-UL2DPD2B.js';
export { config } from './chunk-4JB325EV.js';
import './chunk-AXCKF2IS.js';

// src/config/apply.ts
async function applyConfig(env) {
  switch (env) {
    case "dev":
      return await import('./env-dev-GMLHLQNX.js');
    case "stg":
      return await import('./env-stg-M4N6RCGW.js');
    case "prd":
      return await import('./env-prd-QZIUE3NY.js');
  }
}

export { applyConfig };
